module.exports = __webpack_public_path__ + "img/daiwashoken.d80e9424.jpg";